import { sdkLogger } from '../../logger/logger';
import type { SdkLoggableError } from '../../types/shared';
import type { SubmitInput, SubmitRequestBody } from '../types';

export function logResolvedInputs(resolved: SubmitInput): void {
  sdkLogger.debug('Resolved raw inputs to submit schema:', { resolved });
}

export function logRequestBody(body: SubmitRequestBody): void {
  sdkLogger.debug('Constructed JSON request body:', { body });
}

export function logExecuteSubmitError(err: SdkLoggableError): void {
  sdkLogger.error('Failed to execute submit callback', { err });
}
